import React from "react";
import styled from "styled-components";
import Img from "gatsby-image/withIEPolyfill";

const Image = styled(Img)`
  height: 100%;
  width: 100%;
`;

const Photo = ({photo}) => <Image fluid={photo.childImageSharp.fluid} alt={photo.name.replace(/-/g, ' ').substring(2)}/>;

export default Photo;